import { render, staticRenderFns } from "./ListPromotionBundle.vue?vue&type=template&id=1390117e&scoped=true"
import script from "./ListPromotionBundle.vue?vue&type=script&lang=js"
export * from "./ListPromotionBundle.vue?vue&type=script&lang=js"
import style0 from "./ListPromotionBundle.vue?vue&type=style&index=0&id=1390117e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390117e",
  null
  
)

export default component.exports